import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { CMEMS_SEA_ICE } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

export class CmemsSeaIce extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const id = 'CmemsSeaIce'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { layerRendered, paint, time } = this.props

    const visible = layerRendered
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [CMEMS_SEA_ICE({ timeIso })],
      tileSize: 256
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id='CmemsSeaIce' tileJsonSource={rasterSource} />
        <Layer
          type='raster'
          id='CmemsSeaIce'
          sourceId='CmemsSeaIce'
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={paint}
          before={before}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()

  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'CmemsSeaIce', 'SmartIce'),
      paint: getPaint(state, 'CmemsSeaIce'),
      time: state.layer.times.CmemsSeaIce || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(CmemsSeaIce)



// WEBPACK FOOTER //
// ./src/layers/CmemsSeaIce.js